import { render, staticRenderFns } from "./sso-provider-settings-card.vue?vue&type=template&id=c48f4f8c"
import script from "./sso-provider-settings-card.vue?vue&type=script&lang=js"
export * from "./sso-provider-settings-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports